<template>
  <div class="mpm_upload_img">
    <div class="upload-wrapper">
      <div v-for="file in fileList" :key="file.uid" class="image-item">
        <img :src="file.url" alt="uploaded" />
        <div class="image-actions">
          <a-icon type="eye" class="preview-icon" @click="() => handlePreview(file)" />
          <a-icon type="delete" class="delete-icon" @click="() => handleRemove(file)" />
        </div>
      </div>
      <div v-if="fileList.length < len" class="upload-button" @click="customHandle">
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">
          {{ loading ? '上传中' : '上传' }}
        </div>
      </div>
    </div>
    <a-upload
      :accept="currentAccept"
      :file-list="fileList"
      :remove="handleRemove"
      :custom-request="requestFile"
      :before-upload="beforeUpload"
      @preview="handlePreview"
      @change="handleChange"
      :multiple="len > 1"
      class="hidden-upload"
    ></a-upload>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
<script>
  // import dayjs from 'dayjs'
  import { UPLOAD_CDN_HOST } from '@/config/env'
  import { uploadImage } from '@/config/alioss'
  import Compressor from 'compressorjs' // 引入图片压缩库
  import defaultImg from 'assets/images/default_img.png'

  function getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => resolve(reader.result)
      reader.onerror = (error) => reject(error)
    })
  }

  const accept = {
    image: 'image/*',
    video: 'video/*',
  }

  export default {
    model: {
      prop: 'value',
    },
    props: {
      accept: {
        type: String,
        default: 'image',
      },
      url: String,
      urls: {
        type: Array,
        default: () => {
          return []
        },
      },
      len: {
        type: Number,
        default: 1,
      },
      // 上传的最大体积
      maxSize: {
        type: Number,
        default: 0,
      },
      // 图片宽度
      width: {
        type: Number,
        default: 102,
      },
    },
    created() {
      setTimeout(() => {
        this.filterImage()
      }, 2500)
    },
    data() {
      return {
        currentAccept: accept[this.accept],
        previewVisible: false,
        previewImage: '',
        beforeUploadCheck: true,
        fileList: [],
        loading: false,
        uploadingCount: 0, // 正在上传的文件数量
        defaultImg,
        baseUrl: UPLOAD_CDN_HOST[process.env.VUE_APP_SERVER_ENV],
      }
    },
    methods: {
      customHandle() {
        const button = this.$el.querySelector('.ant-upload input') // 根据实际情况调整选择器，比如按钮的类名可能有变化
        button.click()
      },
      /**
       * 关闭预览事件
       **/
      handleCancel() {
        this.previewVisible = false
      },
      /**
       * 覆盖默认上传方法
       **/
      async requestFile(info) {
        // 增加上传计数
        this.uploadingCount++
        this.loading = true
        this.$emit('setLoading', true)

        try {
          let res = await uploadImage(info.file)
          if (res.url) {
            const newFile = {
              uid: this.$utils.uuid(),
              url: res.url,
              name: res.name,
              status: 'done',
            }

            // 如果是单图模式（len === 1），替换现有图片
            const nextList = this.len === 1 ? [newFile] : [...this.fileList, newFile]
            // 控制最大数量，避免超出 len
            this.fileList = nextList.slice(0, this.len)

            this.$emit('cb', this.fileList)
            this.$emit('cbUrls', this.backImages())
          }
        } catch (error) {
          console.error('图片上传失败:', error)
          this.$message.error('图片上传失败')
        } finally {
          // 减少上传计数
          this.uploadingCount--
          // 只有当所有文件都上传完成时，才取消 loading 状态
          if (this.uploadingCount <= 0) {
            this.uploadingCount = 0
            this.loading = false
            this.$emit('setLoading', false)
          }
        }
      },
      /**
       * 上传前校验
       **/
      beforeUpload(file) {
        console.log('上传文件')
        this.beforeUploadCheck = true
        const isJpgOrPng = file.type.indexOf('image') > -1
        if (!isJpgOrPng) {
          this.$message.error('只能上传图片')
        }
        if (this.maxSize) {
          // 是否大于最大上传体积
          const isExcess = file.size / 1024 / 1024 > this.maxSize
          if (isExcess) {
            this.$message.error(`图片大小不能超过${this.maxSize}MB`)
            return false
          }
        }
        const isLt10M = file.size / 1024 / 1024 <= 10
        // 如果文件大于 10MB，则压缩
        if (!isLt10M) {
          this.$message.warning('正在上传中...')
          this.compressImage(file)
          return false // 阻止默认上传行为，等待压缩完成
        }
        return true // 文件符合要求，继续上传
      },
      // 图片压缩
      compressImage(file) {
        // 压缩前先增加上传计数，因为压缩后会调用 requestFile
        this.uploadingCount++
        this.loading = true
        this.$emit('setLoading', true)

        new Compressor(file, {
          quality: 0.8, // 压缩质量
          // maxWidth: 800, // 限制最大宽度
          // maxHeight: 800, // 限制最大高度
          success: (result) => {
            console.log('压缩后', result)
            this.beforeUploadCheck = true
            // 压缩成功，调用上传方法（注意：这里不要重复增加计数，因为已经在压缩前增加了）
            this.uploadImageDirectly(result)
          },
          error: (err) => {
            console.error('图片压缩失败:', err)
            this.beforeUploadCheck = false
            this.$message.error('图片上传失败')
            // 压缩失败时减少计数
            this.uploadingCount--
            if (this.uploadingCount <= 0) {
              this.uploadingCount = 0
              this.loading = false
              this.$emit('setLoading', false)
            }
          },
        })
      },
      /**
       * 直接上传图片（不增加计数，用于压缩后的上传）
       **/
      async uploadImageDirectly(file) {
        try {
          let res = await uploadImage(file)
          if (res.url) {
            const newFile = {
              uid: this.$utils.uuid(),
              url: res.url,
              name: res.name,
              status: 'done',
            }

            // 如果是单图模式（len === 1），替换现有图片
            const nextList = this.len === 1 ? [newFile] : [...this.fileList, newFile]
            // 控制最大数量，避免超出 len
            this.fileList = nextList.slice(0, this.len)

            this.$emit('cb', this.fileList)
            this.$emit('cbUrls', this.backImages())
          }
        } catch (error) {
          console.error('图片上传失败:', error)
          this.$message.error('图片上传失败')
        } finally {
          // 减少上传计数
          this.uploadingCount--
          if (this.uploadingCount <= 0) {
            this.uploadingCount = 0
            this.loading = false
            this.$emit('setLoading', false)
          }
        }
      },
      /**
       * 删除
       **/

      handleRemove(file) {
        const index = this.fileList.indexOf(file)
        this.fileList.splice(index, 1)
        this.$emit('cb', this.fileList)
        this.$emit('cbUrls', this.backImages())
      },
      async handlePreview(file) {
        if (!file.url && !file.preview) {
          file.preview = await getBase64(file.originFileObj)
        }
        this.previewImage = file.url || file.preview
        this.previewVisible = true
      },
      /**
       * 图片改变
       * @param fileList 上传数组
       * @param event 上传中事件 暂无用
       */
      handleChange({ file, fileList }) {
        if (this.beforeUploadCheck) {
          // 过滤掉上传中的状态文件
          const validFiles = fileList.filter((f) => f.status === 'done')

          // 如果是单图模式，只保留最新的一张
          if (this.len === 1) {
            this.fileList = validFiles.slice(-1)
          } else {
            // 多图模式，保留所有已完成的图片，但不超过指定数量
            this.fileList = validFiles.slice(0, this.len)
          }
        }
      },
      /**
       * 处理图片格式
       */
      filterImage() {
        if (this.url) {
          this.fileList = [
            {
              uid: this.$utils.uuid(),
              url: this.filterUrl(this.url),
              name: this.url,
              status: 'done',
            },
          ]
        }
        if (this.urls.length > 0 && this.urls[0].status === undefined) {
          let result = []
          this.urls.forEach((item, index) => {
            // 确保不超过允许的最大数量
            if (index < this.len) {
              result.push({
                uid: this.$utils.uuid(),
                url: this.filterUrl(item),
                name: item,
                status: 'done',
              })
            }
          })
          this.fileList = result
        }
        if (!this.url && !this.urls.length) {
          this.fileList = []
        }
      },
      /**
       * 过滤图片
       * @param val
       */
      filterUrl(val) {
        console.log('val', val)
        let url = ''
        if (!val || ['null!imageslim', 'null', '!imageslim'].includes(val)) {
          url = defaultImg
        } else if (val.indexOf('://') > -1) {
          url = val
        } else {
          url = this.baseUrl + val
        }
        val = url
        return url
      },
      /**
       * 返回为上传图片原始路径
       * @returns {[]}
       */
      backImages() {
        return this.$utils.getKeyForList(this.fileList, 'name')
      },
    },
  }
</script>
<style scoped lang="scss">
  .mpm_upload_img {
    line-height: 1.4;

    .upload-wrapper {
      display: flex;
      align-items: flex-start;
      gap: 8px;
      flex-wrap: wrap;
    }

    .image-item {
      position: relative;
      width: v-bind('width + "px"');
      height: v-bind('width + "px"');
      border: 1px solid #dcdee0;
      border-radius: 2px;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .image-actions {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.45);
        opacity: 0;
        transition: all 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 16px;

        .anticon {
          color: #fff;
          font-size: 18px;
          cursor: pointer;

          &:hover {
            color: #7468f2;
          }
        }
      }

      &:hover .image-actions {
        opacity: 1;
      }
    }

    .upload-button {
      width: v-bind('width + "px"');
      height: v-bind('width + "px"');
      border: 1px dashed #dcdee0;
      border-radius: 2px;
      background: transparent;
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .anticon {
        font-size: 27px;
        color: #999;
      }

      .ant-upload-text {
        margin-top: 4px;
        color: #666;
        font-size: 12px;
      }

      &:hover {
        border-color: #7468f2;

        .anticon,
        .ant-upload-text {
          color: #7468f2;
        }
      }
    }

    .hidden-upload {
      display: none;
    }
  }
</style>
